(function () {
  function initCrossSell(root) {
    var toggle = root.querySelector('[data-cross-sell-toggle]');
    var panel = root.querySelector('[data-cross-sell-panel]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      root.classList.toggle('is-open');
    });

    panel.addEventListener('click', function (e) { e.stopPropagation(); });

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) root.classList.remove('is-open');
    });
  }

  document.querySelectorAll('[data-a2k-cross-sell]').forEach(initCrossSell);
})();
